import { ArrowRight } from 'lucide-react';
import React from 'react';
import { ArticleCard } from '../components/ArticleCard';
import { Article } from '../types';

interface HomePageProps {
  featuredArticles: Article[];
  onArticleClick: (article: Article) => void;
  onArticlesClick: () => void;
}

export const HomePage: React.FC<HomePageProps> = ({
  featuredArticles,
  onArticleClick,
  onArticlesClick,
}) => (
  <div>
    {/* Hero Section */}
    <section className="mb-24 bg-gradient-to-br from-yellow-400 via-yellow-500 to-orange-500 -mx-6 lg:-mx-12 px-6 lg:px-12 py-24 lg:py-40 shadow-2xl">
      <div className="max-w-5xl">
        <h2 className="text-7xl md:text-8xl lg:text-9xl font-display font-black text-black mb-8 leading-none uppercase tracking-tighter">
          Tervetuloa! <img src="./beisi.png" alt="beisi" className="inline-block" />
        </h2>
        <p className="text-3xl md:text-4xl text-black font-headline font-bold leading-tight mb-12 max-w-3xl">
          Tutustu viimeisimpiin uutisiin ja tarinoihin!
        </p>
        <button
          onClick={onArticlesClick}
          className="inline-flex items-center gap-3 bg-black text-yellow-400 px-12 py-6 text-2xl font-display font-black hover:bg-gray-900 transition-all shadow-2xl hover:shadow-3xl uppercase tracking-wider"
        >
          Lue lisää <ArrowRight size={28} strokeWidth={4} />
        </button>
      </div>
    </section>

    <section>
      <h2 className="text-6xl md:text-7xl font-display font-black mb-16 text-gray-900 uppercase tracking-tighter">
        Suosittelemme
      </h2>
      {featuredArticles.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
          {featuredArticles.map(article => (
            <ArticleCard
              key={article.id}
              article={article}
              onClick={() => onArticleClick(article)}
            />
          ))}
        </div>
      ) : (
        <p className="text-gray-700 text-xl font-headline font-bold">Ei suositeltavia artikkeleita.</p>
      )}
    </section>
  </div>
);